module.exports = __webpack_public_path__ + "static/media/sunny.15064e46.mov";